<script>
export default {};
</script>

<template lang='pug'>
router-view
</template>

<style>
@import '~import/index';
</style>